import checkIfMobile from 'is-mobile';

export const isMobile = checkIfMobile({ tablet: true, featureDetect: true });
